module.exports = __webpack_public_path__ + "static/img/logo.f51c1dbf.png";